import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-51516206")

_pushScopeId("data-v-51516206")
const _hoisted_1 = { class: "tab-wrap d-f" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      id: "tab-l",
      class: ['tab-item', {active:_ctx.actIndex===0}],
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.swichTab(0)))
    }, _toDisplayString(_ctx.tabs[0]), 3),
    _createVNode("div", {
      id: "tab-r",
      class: ['tab-item', {active:_ctx.actIndex===1}],
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.swichTab(1)))
    }, _toDisplayString(_ctx.tabs[1]), 3),
    _createVNode("div", {
      id: "s-l",
      ref: "sLine",
      class: ['s-line left',{'right': _ctx.actIndex===1}]
    }, null, 2)
  ]))
})